var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap2 = function SvgMap2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.88 20.94c-.95.7-2.2 1.06-3.69 1.06H7.81c-.24 0-.48-.01-.71-.04l6.9-6.9zM22 7.81v8.38c0 1.49-.36 2.74-1.06 3.69L15.06 14l6.9-6.9c.03.23.04.47.04.71",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.06 14 5.88 5.88c-.29.42-.64.77-1.06 1.06L14 15.06l-6.9 6.9c-.64-.04-1.22-.17-1.75-.37C3.21 20.81 2 18.91 2 16.19V7.81C2 4.17 4.17 2 7.81 2h8.38c2.72 0 4.62 1.21 5.4 3.35.2.53.33 1.11.37 1.75z",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.06 14 5.88 5.88c-.29.42-.64.77-1.06 1.06L14 15.06l-6.9 6.9c-.64-.04-1.22-.17-1.75-.37l.39-.39L21.59 5.35c.2.53.33 1.11.37 1.75zM12.24 7.93c-.38-1.65-1.84-2.39-3.12-2.4-1.28 0-2.74.74-3.12 2.39-.42 1.83.7 3.36 1.71 4.32.4.38.9.56 1.41.56s1.01-.19 1.41-.56c1.01-.96 2.13-2.49 1.71-4.31M9.15 9.49c-.55 0-1-.45-1-1s.44-1 1-1h.01c.55 0 1 .45 1 1s-.46 1-1.01 1"
  })));
};
export default SvgMap2;